module.exports = __webpack_public_path__ + "img/technological_turbine.b218b758.svg";